import { useState } from "react";
import { ChevronLeft, ChevronRight, X, CornerDownLeft } from "lucide-react";

/* Panneau « Questions 1 sur 3 » : réponses à choix + réponse libre, puis envoi groupé. */
export const AssistantQuestions = ({ questions, onSubmit, onDismiss, busy }) => {
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState(() => questions.map(() => ""));
  const [custom, setCustom] = useState("");
  const total = questions.length;
  const q = questions[index];
  const last = index === total - 1;

  const commit = (value) => {
    const next = [...answers];
    next[index] = value || "Sans préférence";
    setAnswers(next);
    setCustom("");
    if (last) onSubmit(next);
    else setIndex(index + 1);
  };

  return (
    <div data-testid="assistant-questions" className="rounded-2xl border border-[#E2E7F7] bg-white p-4 shadow-[0_-8px_30px_-12px_rgba(15,38,69,0.18)]">
      <div className="mb-3 flex items-center justify-between">
        <p className="font-heading text-base font-bold text-[#0F2645]">Questions</p>
        <div className="flex items-center gap-1 text-sm text-[#5C6A87]">
          <button type="button" data-testid="assistant-questions-prev" disabled={index === 0} onClick={() => setIndex(index - 1)} className="inline-flex h-8 w-8 items-center justify-center rounded-lg hover:bg-slate-100 disabled:opacity-30">
            <ChevronLeft className="h-4 w-4" />
          </button>
          <span data-testid="assistant-questions-counter" className="tabular-nums">{index + 1} sur {total}</span>
          <button type="button" data-testid="assistant-questions-next" disabled={last} onClick={() => setIndex(index + 1)} className="inline-flex h-8 w-8 items-center justify-center rounded-lg hover:bg-slate-100 disabled:opacity-30">
            <ChevronRight className="h-4 w-4" />
          </button>
          <button type="button" data-testid="assistant-questions-close" onClick={onDismiss} className="ml-1 inline-flex h-8 w-8 items-center justify-center rounded-lg text-[#93A0BC] hover:bg-slate-100">
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
      <p data-testid="assistant-question-text" className="mb-3 text-[15px] font-semibold leading-snug text-[#0F2645]">{q.question}</p>
      <div className="space-y-2">
        {q.options.map((opt, i) => (
          <button
            key={opt}
            type="button"
            data-testid={`assistant-option-${i + 1}`}
            disabled={busy}
            onClick={() => commit(opt)}
            className={`group flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left text-[15px] transition-colors duration-150 ${
              answers[index] === opt ? "border-[#3A5CC8] bg-[#EEF1FC] text-[#2F4CA8]" : "border-[#E2E7F7] bg-white text-[#0F2645] hover:border-[#C9D4F4] hover:bg-[#F6F8FD]"
            }`}
          >
            <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#0F2645] font-mono text-xs font-bold text-white">{i + 1}</span>
            <span className="flex-1">{opt}</span>
            <CornerDownLeft className="h-4 w-4 text-[#C9D4F4] opacity-0 transition-opacity group-hover:opacity-100" />
          </button>
        ))}
        <form
          onSubmit={(e) => { e.preventDefault(); commit(custom.trim()); }}
          className="flex items-center gap-2 rounded-xl border border-[#E2E7F7] bg-[#F6F8FD] py-1.5 pl-3 pr-1.5"
        >
          <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-[#E2E7F7] bg-white font-mono text-xs font-bold text-[#5C6A87]">{q.options.length + 1}</span>
          <input
            data-testid="assistant-option-custom"
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            placeholder="Autre réponse…"
            className="min-w-0 flex-1 bg-transparent text-[15px] text-[#0F2645] placeholder:text-[#93A0BC] focus:outline-none"
          />
          <button type="submit" data-testid="assistant-questions-submit" disabled={busy} className="inline-flex min-h-[38px] items-center rounded-xl bg-[#3A5CC8] px-4 text-sm font-semibold text-white hover:bg-[#2F4CA8] disabled:opacity-40">
            {last ? "Créer le devis" : "Suivant"}
          </button>
        </form>
      </div>
    </div>
  );
};
